import React from 'react';
import {  Row, Col,ListGroup,ListGroupItem} from 'reactstrap';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';

class daryaftman extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isloading:true,
            activeTab: 1,
            data:[{"Id":47768499,"PayDate":"1394/11/20","GirandeName":"محمدرضا احمدي کد 2037361","Amount":7480000,"Sharh":"سند پرداخت ويژه شماره حواله 12434 با شناسه عددي 3801125904 تاريخ ‎1394/11/20 ب: بانک ملت  ش: ميرداماد  ح: ‎53313497/72  ","ItemKind":"وام","TasviyeDate":"1394/11/19","ErrorMessage":null},{"Id":67349589,"PayDate":"1397/02/03","GirandeName":"محمدرضا احمدي کد 2037361","Amount":20000000,"Sharh":"سند پرداخت ويژه شماره حواله 102078 با شناسه عددي 3801125904 تاريخ ‎1397/02/03 ب: بانک ملت  ش: ميرداماد  ح: ‎53313497/72  ","ItemKind":"وام","TasviyeDate":"1397/02/03","ErrorMessage":null}]
        }
        this.state.data = [] ;
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/MlDaryafti",
           
                {codeMelli:UserManager.MelliCode()}
                
            ),
            BimeManager.header())
            .then((result)=>{
              console.log("result.data : ",JSON.stringify(result.data));
                this.setState({data:result.data,isloading:false})//

            })
            .catch((error) => { alert(error) })   
    }

   
    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>مشاهده دریافتهای من</h4>
                    </Col>
                </Row>
       
{ (!this.state.isloading)?(
            <div className="container ListOfList">
                                <ListGroup>
                                    <ListGroupItem >
                                        
                                       {this.state.data.map((dataa)=>{
                                           return(

                                               <div>
                                                    <div className="container ListOfList">
                                          <Row>
                                            <Col sm="12" className="alignRight"><span className="bold-head">دریافت کننده:</span>{dataa.GirandeName}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">نوع:</span>{dataa.ItemKind}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">تاریخ:</span>{dataa.PayDate}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">تاریخ تسویه:</span>{dataa.TasviyeDate}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">مبلغ:</span>{libs.StringFunctions.currancyPrint(dataa.Amount)+('ریال')}</Col>
                                            <Col sm="12" className="alignRight"><span className="bold-head">شرح:</span>{dataa.Sharh}</Col>
                                                  </Row>
                                           </div>
                                           </div>
                                                 )
                                                }  ) 
                                            }
                                            
                                        </ListGroupItem>
                                </ListGroup>
            </div>
           ):(<ui.Preloader />)

}   
</div>
        )
    
}
    }

export default daryaftman;


// WEBPACK FOOTER //
// ./src/components/Daryafti/daryaftman.js